import React from "react";
import {
  Box,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import useLogout from "../../../hooks/useLogout";
import { useSelector } from "react-redux";
import { RootState} from "../../../../app/features/store/store";
import { useNavigate } from "react-router-dom";

const UserMenu = () => {
  const logout = useLogout();
  const navigate = useNavigate();
  const { authResponse } = useSelector((state: RootState) => state.login);

  const userName = authResponse?.userSettings?.userName;
  const roles = authResponse?.userSettings?.roles.toString();

  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = () => {
    setAnchorElUser(null);
    logout();
  };

  const handleResetPassword = () => {
    setAnchorElUser(null);
    navigate("/reset-password");
  };

  return (
    <Box sx={{ flexGrow: 0 }}>
      <IconButton
        size="medium"
        sx={{ p: 1, color: "white" }}
        onClick={handleOpenUserMenu}
      >
        <PersonIcon />
      </IconButton>
      <Menu
        marginThreshold={0}
        sx={{ mt: "45px" }}
        id="menu-appBar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
        slotProps={{
          paper: {
            ...{
              sx: {
                overflow: "visible",
                minHeight: 130,
                top: "0px !important",
                backgroundColor: "white",
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "white",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            },
          },
        }}
      >
        <MenuItem key={"userDetails"}>
          <Typography textAlign="center">{userName?.toUpperCase()}</Typography>
        </MenuItem>
        <Divider />
        <MenuItem key={"roles"} sx={{ cursor: "default" }}>
          <Typography
            textAlign="left"
            color="InfoText"
            sx={{ fontSize: "smaller" }}
          >
            {roles}
          </Typography>
        </MenuItem>
        <Divider />
        <MenuItem key={"resetPassword"} onClick={handleResetPassword}>
          <Typography textAlign="center">Reset Password</Typography>
        </MenuItem>
        <Divider />
        <MenuItem key={"logOut"} onClick={handleLogout}>
          <Typography textAlign="center">Logout</Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default UserMenu;
